(function () {
    'use strict';

    angular
        .module('app.clubAdmin')
        .constant('subgroupsResolver', {
            clubId: create('clubId'),
            subgroupList: create('subgroupList'),
            subgroup: create('subgroup'),
            members: create('members')
        });

    var extend = angular.extend;

    function create(property) {
        resolve.$inject = ['$q', '$transition$', 'Club'];
        return resolve;

        function resolve($q, $transition$, Club) {
            if (!$transition$.resolvePromise)
                $transition$.resolvePromise = $q.resolve({}).then(getSubgroups).then(getMembers);
            return $transition$.resolvePromise.then(pluck);

            ///////////////////////////////

            function getSubgroups(result) {
                var clubId = result.clubId = $transition$.params().clubId;
                return Club.getSubgroups({ id: clubId }, true).$promise.then(chainResult);

                function chainResult(subgroupList) {
                    var subgroup = subgroupList && subgroupList[0] || null;
                    return extend(result, { subgroupList: subgroupList, subgroup: subgroup });
                }
            }

            function getMembers(result) {
                var clubId = result.clubId,
                    subgroupId = result.subgroup && result.subgroup.id || null;

                return subgroupId ? Club.getSubgroupMembers({ id: clubId, clubSubgroupId: subgroupId }, true).$promise.then(chainResult) : chainResult([]);

                function chainResult(members) {
                    return extend(result, { members: members });
                }
            }

            function pluck(result) {
                return result[property];
            }
        }
    }
})();